import controller from './list.controller';

const template = require('./list.html');

export default {
    bindings: {
        searchQuery: '<'
    },
    template,
    controller
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/list/list.component.js